let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5muK5")).then(() => parcelRequire('co8Yt'));